export var PHONE_TYPES_THAT_CAN_RECEIVE_WRITTEN_COMMUNICATION = ['mobile'];
export var PHONE_TYPE_OPTIONS = [{
  display_name: 'Phone',
  value: 'phone'
}, {
  display_name: 'Fax',
  value: 'fax'
}, {
  display_name: 'Other',
  value: 'other'
}];
export var PHONE_TYPE_FAX = 'fax';
//# sourceMappingURL=constants.js.map